import React from 'react';
import Nav from '@fiverr-private/header/src/lib/Nav';
import Layout from '@fiverr-private/header/src/components/Layout';
import MainRow from '@fiverr-private/header/src/components/MainRow';
import LoginLink from '@fiverr-private/header/src/components/LoginLink';
import JoinLink from '@fiverr-private/header/src/components/JoinLink';
import FiverrLink from '@fiverr-private/header/src/components/FiverrLink';
import withContext from '@fiverr-private/header/src/lib/withContext';
import EducHubLogo from './EducateHubLogo';
import { Navicon } from './Navicon';

import './style.scss';

const EducateHubLoggedOutHeader = () => (
  <Layout className="educate-hub-header">
    <MainRow>
      <Navicon />
      <EducHubLogo />
      <Nav alignToRight>
        <Nav.Item displayFromSM>
          <FiverrLink />
        </Nav.Item>
        <Nav.Item displayFromSM>
          <LoginLink />
        </Nav.Item>
        <Nav.Item>
          <JoinLink />
        </Nav.Item>
      </Nav>
    </MainRow>
  </Layout>
);

export default withContext(EducateHubLoggedOutHeader);
